export const LANG_DISCREP_MODAL_DISPLAY_KEY = 'intlLangDiscrepModalDisplayed' as const;
